import { ThemeConfig } from "antd-v5";

export const ANTD_V5_THEME: ThemeConfig = {
  token: {
    colorPrimary: "#745CD1",
    colorLink: "#745CD1",
    borderRadius: 6,
    fontFamily: "InterVariable, sans-serif",
    fontSize: 13.75,
    colorText: "rgb(52, 64, 84)",
    colorTextDescription: "rgba(102, 112, 133 , .8)",
  },
  components: {
    Typography: { linkDecoration: "underline" },
    Table: {
      headerBorderRadius: 0,
      cellPaddingBlockMD: 12,
      cellPaddingInlineMD: 16,
    },
    Drawer: {
      padding: 16,
      paddingLG: 24,
      fontSizeLG: 18,
    },
    Modal: {
      titleFontSize: 13.75,
      titleLineHeight: 1.7,
      titleColor: "#000",
      footerBg: "#F9FAFB",
      headerBg: "#F9FAFB",
      borderRadiusLG: 12,
    },
    Form: {
      labelColor: "#182230",
      itemMarginBottom: 16,
    },
  },
};
